module.exports = __webpack_public_path__ + "static/media/help3.6ca516e8.png";